import { render, staticRenderFns } from "./JSelectZyByZyb.vue?vue&type=template&id=bbfc7492&scoped=true"
import script from "./JSelectZyByZyb.vue?vue&type=script&lang=js"
export * from "./JSelectZyByZyb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc7492",
  null
  
)

export default component.exports